module.exports = __webpack_public_path__ + "static/media/like_plein.a62300c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/like_plein.svg
// module id = 595
// module chunks = 0